import { site } from "../content";
import { Icon } from "./Icon";
import { Reveal, SectionHeading } from "./Reveal";

export default function Problem() {
  return (
    <section id="problema" data-testid="problem-section" className="relative overflow-x-clip py-24 md:py-36">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <SectionHeading
          chapter="01"
          eyebrow="O problema"
          title="Ainda preparando toalhas de forma improvisada?"
          testId="problem-heading"
        />

        <div className="mt-16 grid gap-6 md:grid-cols-3">
          {site.problems.map((p, i) => (
            <Reveal key={p.title} delay={i * 0.1}>
              <div
                data-testid={`problem-card-${i}`}
                className="group h-full rounded-2xl border border-white/10 bg-graphite/60 p-8 backdrop-blur-xl transition-[border-color,transform] duration-500 hover:-translate-y-1.5 hover:border-red-400/30"
              >
                <div className="flex h-12 w-12 items-center justify-center rounded-xl border border-white/10 bg-white/5 text-bone/60 transition-colors duration-500 group-hover:text-red-300">
                  <Icon name={p.icon} className="h-5 w-5" />
                </div>
                <h3 className="mt-6 font-display text-lg font-bold uppercase tracking-wide text-bone">
                  {p.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-bone/55">{p.text}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-24 grid items-center gap-12 lg:grid-cols-2">
          <Reveal>
            <p className="flex items-center gap-4">
              <span className="font-display text-xs font-bold tracking-[0.4em] text-gold">
                01.5
              </span>
              <span className="h-px w-10 bg-gold/50" aria-hidden="true" />
              <span className="font-serif text-lg italic text-bone/60">A solução</span>
            </p>
            <h3 className="mt-6 font-display text-3xl font-extrabold uppercase leading-tight tracking-tight text-bone sm:text-4xl">
              Existe uma forma <span className="text-gold">mais profissional.</span>
            </h3>
            <p className="mt-6 max-w-md text-base leading-relaxed text-bone/60">
              Um equipamento desenvolvido do zero para a rotina da barbearia —
              sem improviso, sem interrupções, sem métodos adaptados.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="relative">
              <div className="spotlight-gold absolute inset-0 scale-125" aria-hidden="true" />
              <div className="absolute -inset-3 rounded-3xl border border-gold/25" aria-hidden="true" />
              <img
                src={site.assets.cutout}
                alt="Barber Steamer — aquecedor profissional de toalhas para barbearia"
                loading="lazy"
                data-testid="problem-solution-image"
                className="relative aspect-square w-full rounded-2xl border border-white/10 bg-graphite/50 object-contain p-10 shadow-[0_32px_80px_rgba(0,0,0,0.6)]"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
